import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';
import { Control, Controller, FieldValues, UseFormUnregister } from 'react-hook-form';

type RHFRestFirldCheckBoxProps = {
  name: string;
  control: Control<any>;
  rules?: Object;
  defaultChecked?: boolean;
  label?: any;
  fieldName: string[];
  unregister: UseFormUnregister<FieldValues>;
  disabled?: boolean;
};

const RHFUnRegisterCheckBox = ({ name, control, rules, defaultChecked, label, fieldName, unregister, disabled }: RHFRestFirldCheckBoxProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormControlLabel
          {...field}
          control={
            <Checkbox
              defaultChecked={defaultChecked}
              checked={Boolean(field.value)}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                field.onChange(event.target.checked);
                unregister(fieldName);
              }}
              disabled={disabled}
            />
          }
          label={label}
        />
      )}
    />
  );
};

export default RHFUnRegisterCheckBox;
